import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./index.module.css";
import { Browser } from "@/03-widgets/browser/ui";
import { Editor } from "@/03-widgets/editor";
import { Path } from "@/03-widgets/path";
import { SearchBar } from "@/03-widgets/search-bar";
import { Topbar } from "@/03-widgets/topbar";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router";
export const TreePage = ({ currentDirectoryId, path }) => {
    const navigate = useNavigate();
    const [readmeDocumentId, setReadmeDocumentId] = useState(null);
    const handleDocumentsLoaded = useCallback((documents) => {
        var _a;
        const readme = documents.find((document) => (document.type === "document" && document.title === "README"));
        setReadmeDocumentId((_a = readme === null || readme === void 0 ? void 0 : readme.id) !== null && _a !== void 0 ? _a : null);
    }, []);
    return (_jsxs("div", Object.assign({ className: styles.pageWrapper }, { children: [_jsx(Topbar, { children: _jsx(SearchBar, {}) }), _jsxs("div", Object.assign({ className: styles.treeWrapper }, { children: [_jsx(Path, { path: path, onNavigate: (id) => navigate(id === null ? "/" : `/${id}`) }), readmeDocumentId !== null ? (_jsx("div", Object.assign({ className: styles.readmeWrapper }, { children: _jsx(Editor, { showTitle: false, documentId: readmeDocumentId }) }))) : null, _jsx(Browser, { parentId: currentDirectoryId, onDocumentsLoaded: handleDocumentsLoaded })] }))] })));
};
